module.exports = __webpack_public_path__ + "static/media/room-10.3b5c0871.jpeg";